import { NavLink } from 'react-router-dom';
import AdminLayout from '../../layout/AdminLayout';
import DatePicker from 'react-datepicker';

import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDidMountEffect from '../../hooks/useDidMountEffect';

// 헬퍼 함수: 무조건 YYYY-MM 문자열만 반환
const getYearMonth = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export default function DiscountCodeIncentiveCurrent() {
  const [incentiveList, setIncentiveList] = useState([]);
  const [lvList, setLvList] = useState([]);
  const today = new Date();

  const [startDate, setStartDate] = useState(today);

  // 초기값부터 YYYY-MM으로 설정
  const [search, setSearch] = useState({
    searchMonth: getYearMonth(today),
    viewType: 'M',
    lv: ''
  });

  const getIncentiveList = () => {
    Server.sendGet('shopify/sales/incentive/discount', search, getIncentiveListCallback).then();
  }

  const getIncentiveListCallback = res => {
    setIncentiveList(res?.['resultList'] || []);
  }

  const getSalesLvList = () => {
    Server.sendGet('shopify/sales/lv', {}, getSalesLvListCallback).then();
  }

  const getSalesLvListCallback = res => {
    setLvList(res?.['resultList'] || []);
  }

  const changeDateType = value => {
    setStartDate(today);
    setSearch((prev) => ({
      ...prev,
      viewType: value,
      searchMonth: getYearMonth(today), // YYYY-MM
    }));
  };

  const changeStartDate = date => {
    setStartDate(date);
    setSearch((prev) => ({
      ...prev,
      searchMonth: getYearMonth(date), // YYYY-MM
    }));
  };

  useEffect(() => {
    getSalesLvList();
    getIncentiveList();
  }, []);

  useDidMountEffect(() => {
    getIncentiveList();
  }, [search]);

  return (
    <AdminLayout>
      <div className='title'>
        <div className='tit-head'>
          <i />
          <h4>Promo code Incentive</h4>
        </div>
      </div>
      <div className="util-menu">
        <div className="menu-in">
          <CateIn>
            <Cate>
              <CateSel
                value={search?.viewType}
                onChange={e => changeDateType(e.target.value)}
              >
                <option value={'M'}>Monthly</option>
                <option value={'Y'}>Yearly</option>
              </CateSel>
            </Cate>
          </CateIn>
          <div className='item-in'>
            <DatePicker
              selected={startDate}
              dateFormat={search.viewType === 'M' ? 'yyyy-MM' : 'yyyy'}
              onChange={date => changeStartDate(date)}
              showMonthYearPicker={search.viewType === 'M'}
              showYearPicker={search.viewType === 'Y'}
            />
          </div>
        </div>
      </div>
      <div className="content">
        <table className="admin-table">
          <thead>
          <tr>
            <th>Promo Code</th>
            <th>Sales Count</th>
            <th>Total Amount</th>
            <th>Incentive %</th>
            <th>Estimated Commission</th>
          </tr>
          </thead>
          <tbody>
          {incentiveList?.map((item, idx) => (
            <tr key={idx}>
              <td>{item.discountCode}</td>
              <td>{item.totalOrderCount}</td>
              <td>{Number(item.totalSalesAmount || 0).toLocaleString()}</td>
              <td>{Number(item.incentivePercent || 0).toLocaleString()}</td>
              <td>{Number(item.totalIncentivePayout || 0).toLocaleString()}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}

const Btn = styled.button`
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  border-radius: 5px;
  background: #0072b9;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  border: none;
  cursor: pointer;
`;

const CateIn = styled.div` display: flex; align-items: center; gap: 0 20px; `;
const Cate = styled.div` display: flex; align-items: center; gap: 0 10px; `;
const CateSel = styled.select`
  width: 150px;
  height: 40px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;
